package com.wintermar.inspection.core.data

import com.russhwolf.settings.Settings

class AppSetting(private val settings: Settings) {
    private val _tokenKey = "auth.token"
    private val _refreshTokenKey = "auth.refresh"
    private val _userIdKey = "auth.user.id"
    private val _userFullNameKey = "auth.user.fullName"
    private val _inspectionAccess = "access.inspection"
    private val _templateAccess = "access.template"

    var authToken: String?
        get() = getToken(settings = settings, key = _tokenKey)
        set(value) {
            setToken(
                settings = settings,
                key = _tokenKey,
                token = value
            )
        }

    var refreshToken: String?
        get() = settings.getStringOrNull(_refreshTokenKey).takeIf { it?.isNotEmpty() == true }
        set(value) {
            if (value.isNullOrEmpty()) settings.remove(_refreshTokenKey)
            else settings.putString(_refreshTokenKey, value)
        }

    var userId: String?
        get() = settings.getStringOrNull(_userIdKey).takeIf { it?.isNotEmpty() == true }
        set(value) {
            if (value.isNullOrEmpty()) settings.remove(_userIdKey)
            else settings.putString(_userIdKey, value)
        }

    var userFullName: String?
        get() = settings.getStringOrNull(_userFullNameKey).takeIf { it?.isNotEmpty() == true }
        set(value) {
            if (value.isNullOrEmpty()) settings.remove(_userFullNameKey)
            else settings.putString(_userFullNameKey, value)
        }

    var inspectionAccess: Boolean?
        get() = settings.getBooleanOrNull(_inspectionAccess) ?: false
        set(value) {
            if (value == null) settings.remove(_inspectionAccess)
            else settings.putBoolean(_inspectionAccess, value)
        }

    var templateAccess: Boolean?
        get() = settings.getBooleanOrNull(_templateAccess) ?: false
        set(value) {
            if (value == null) settings.remove(_templateAccess)
            else settings.putBoolean(_templateAccess, value)
        }

    fun logout() {
        authToken = null
        refreshToken = null
        userId = null
        userFullName = null
        inspectionAccess = null
        templateAccess = null
    }

    fun isLoggedIn(): Boolean = !authToken.isNullOrEmpty()

    fun setToken(
        authToken: String = "",
        refreshToken: String = "",
        userId: String,
        userFullName: String
    ) {
        this.authToken = authToken
        this.refreshToken = refreshToken
        this.userId = userId
        this.userFullName = userFullName
    }

    fun setNewToken(authToken: String, refreshToken: String) {
        this.authToken = authToken
        this.refreshToken = refreshToken
    }

    fun setAccess(inspectionAccess: Boolean, templateAccess: Boolean) {
        this.inspectionAccess = inspectionAccess
        this.templateAccess = templateAccess
    }
}

expect fun getToken(settings: Settings, key: String): String?
expect fun setToken(settings: Settings, key: String, token: String?)
